export default [
  {
    path: "cms-management",
    name: "cmsmanagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/CMS/pages/cms-management/ManagementSystem.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "folder-management",
    name: "foldermanagement",
    component: () =>
      import("@/views/adminPanel/pages/CMS/pages/folder-management/Folder.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "analytics",
    name: "Analytics",
    component: () =>
      import(
        "@/views/adminPanel/pages/CMS/pages/cms-management/components/Analytics.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "SEO",
    name: "SEO",
    component: () => import("@/views/adminPanel/pages/CMS/pages/seo/SEO.vue"),
    meta: {
      rule: "editor",
    },
  },

  //SmartForms

  {
    path: "smartforms",
    name: "smartforms",
    component: () =>
      import(
        "@/views/adminPanel/pages/CMS/pages/cms-management/components/SmartForms.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  //WebsiteMedia
  {
    path: "WebsiteMedia",
    name: "WebsiteMedia",
    component: () => import("@/views/adminPanel/pages/CMS/pages/Media.vue"),
    // import(
    //     "@/views/adminPanel/pages/CMS/pages/cms-management/components/WebsiteMedia.vue"
    //   ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "WebsiteForm",
    name: "WebsiteForm",
    component: () => import("@/views/adminPanel/pages/CMS/pages/CMSPages.vue"),
    // import(
    //     "@/views/adminPanel/pages/CMS/pages/cms-management/components/WebsiteMedia.vue"
    //   ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "WebsiteMenu",
    name: "WebsiteMenu",
    component: () => import("@/views/adminPanel/pages/CMS/CmsMenu.vue"),
    // import(
    //     "@/views/adminPanel/pages/CMS/pages/cms-management/components/WebsiteMedia.vue"
    //   ),
    meta: {
      rule: "editor",
    },
  },
];
